<template>
  <div id="question-survey" class="p-reletive w-100 h-100 mt-3 text-black">
    <div
      class="p-absolute h-100 w-100"
      @click="unActiveQuestion((activeIndex = null)), toggleActive()"
    ></div>
    <div class="p-survey-wrp" :class="!formData.isEdit ? 'bypass' : ''">
      <div
        class="card-inner list-group-item item"
        v-for="(section, index) in formQuestion"
        :key="section.sectionId"
      >
        <div>
          <div
            class="bg-white py-1 mb-1 section-wrp"
            @click="unActiveQuestion((activeIndex = null))"
          >
            <div class="d-flex justify-content-between">
              <div
                @click="
                  toggleActive(activeHover.SECTION_NAME, section.sectionId)
                "
                class="w-100"
              >
                <div
                  class="d-flex w-100 cursor-pointer"
                  :class="
                    section.sectionId == formDataActive.activeName
                      ? 'bg'
                      : 'bg-hover'
                  "
                >
                  <div
                    class="w-100"
                    :class="
                      section.sectionId == formDataActive.activeName
                        ? 'card-inner'
                        : 'card-inner-hover'
                    "
                  >
                    <div
                      class="editor font-medium-5"
                      v-if="
                        section.sectionId != formDataActive.activeName &&
                        section.sectionName
                      "
                      v-safe-html="section.sectionName"
                    ></div>
                    <div
                      class="text-no-data-wrp"
                      v-if="
                        section.sectionId != formDataActive.activeName &&
                        !section.sectionName
                      "
                    >
                      <div
                        data-placeholder="Section Name"
                        class="text-no-data font-medium-5 w-80"
                      ></div>
                    </div>
                    <div
                      id="toolbar-editor"
                      v-if="section.sectionId == formDataActive.activeName"
                    >
                      <quill-editor
                        id="survey-quill"
                        toolbar="#my-toolbar"
                        ref="sectionNameQuill"
                        class="custom-quill-editor flex-stretch h-100"
                        :options="customQuillOption"
                        v-model="section.sectionName"
                        required
                      >
                      </quill-editor>
                    </div>
                  </div>
                  <div
                    class="count-section-wrp mr-4"
                    v-if="section.sectionId != formDataActive.activeName"
                  >
                    Section {{ index + 1 }} /
                    {{ formQuestion.length }}
                  </div>
                </div>
                <div
                  id="toolbar-editor"
                  v-if="section.sectionId == formDataActive.activeName"
                  class="toolbar-wrp"
                >
                  <div id="my-toolbar">
                    <custom-toolbar
                      :isListbullet="true"
                      :isListOrdered="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-item-end">
              <div class="w-100">
                <div
                  class="d-flex w-100 cursor-pointer p-relative"
                  :class="
                    section.sectionId == formDataActive.activeDesc
                      ? 'bg'
                      : 'bg-hover'
                  "
                >
                  <div
                    class="w-100"
                    :class="
                      section.sectionId == formDataActive.activeDesc
                        ? 'card-inner'
                        : 'card-inner-hover'
                    "
                    @click="
                      toggleActive(activeHover.SECTION_DESC, section.sectionId)
                    "
                  >
                    <div
                      class="editor font-medium-5"
                      v-if="
                        section.sectionId != formDataActive.activeDesc &&
                        section.sectionDesc
                      "
                      v-safe-html="section.sectionDesc"
                    ></div>

                    <div
                      class="text-no-data-wrp"
                      v-if="
                        section.sectionId != formDataActive.activeDesc &&
                        !section.sectionDesc
                      "
                    >
                      <div
                        data-placeholder="Section Description"
                        class="text-no-data font-medium-5 w-80"
                      ></div>
                    </div>
                    <div
                      id="toolbar-editor"
                      v-if="section.sectionId == formDataActive.activeDesc"
                    >
                      <quill-editor
                        id="survey-quill"
                        toolbar="#my-toolbar"
                        ref="sectionDescQuill"
                        class="custom-quill-editor flex-stretch h-100 font-medium-5"
                        :options="customQuillOption"
                        v-model="section.sectionDesc"
                        required
                      >
                      </quill-editor>
                    </div>
                  </div>
                  <div class="mb-1 cursor-pointer action-list-wrp">
                    <action-group
                      class="mr-4 icon-container"
                      v-if="section.sectionId != formDataActive.activeDesc"
                      :resolve-action="resolveSectionAction"
                      :set-action-list="resolveActionList(index)"
                      :item-data="section"
                    />
                  </div>
                </div>
                <div
                  id="toolbar-editor"
                  v-if="section.sectionId == formDataActive.activeDesc"
                  class="toolbar-wrp d-flex justify-content-between"
                >
                  <div id="my-toolbar">
                    <custom-toolbar
                      :isListbullet="true"
                      :isListOrdered="true"
                    />
                  </div>
                  <action-group
                    class="mr-4 action-list-active-wrp"
                    v-if="section.sectionId == formDataActive.activeDesc"
                    :resolve-action="resolveSectionAction"
                    :set-action-list="resolveActionList(index)"
                    :item-data="section"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div @click="toggleActive">
          <draggable
            :componentData="componentData"
            :list="section.question"
            :animation="100"
            @start="dragging = true"
            @end="dragging = false"
            handle=".handle"
            item-key="name"
            class="question-wrp"
            ghost-class="ghost"
            dragClass="dragging"
            :scroll-sensitivity="200"
            :force-fallback="true"
          >
            <div
              class="card-inner reorder-wrp list-group-item item"
              v-for="(question, idx) in section.question"
              :key="question.questionId"
            >
              <div class="w-100">
                <survey-item
                  @mouseenter.native="onHover(question.questionId, true)"
                  @mouseleave.native="onHover(question.questionId, false)"
                  :class="
                    question.questionId === activeIndex
                      ? 'bg-question'
                      : 'bg-hover bg-question-hover'
                  "
                  :formQuestion="question"
                  :formSection="section"
                  :optionQuestion="optionQuestion"
                  :hoverQestionId="hoverQestionId"
                  :questionId="question.questionId"
                  :active="question.questionId === activeIndex"
                  :activeEditor="activeEditor"
                  :isEdit="isEditForm"
                  @set-active="activeIndex = $event"
                  @onAddChoice="onAddChoice"
                  @onAddOther="onAddOther"
                  @onRemoveChoice="onRemoveChoice"
                  @onUploadImage="onUploadImage"
                  @onUploadImageChoice="onUploadImageChoice"
                  @onDuplicateQuestion="onDuplicateQuestion($event, section)"
                  @deleteQuestion="
                    $emit(
                      'deleteQuestion',
                      $event,
                      section.sectionId,
                      question,
                      idx
                    )
                  "
                  @EditQuestion="$emit('EditQuestion')"
                />
              </div>
            </div>
          </draggable>
          <div class="p-relative mb-4" role="group" key="footer">
            <div
              class="btn-group list-group-item"
              v-for="(question, idx) in section.question"
              :key="idx"
            >
              <div>
                <div class="render" v-if="question.questionId === activeIndex">
                  <action-group
                    v-if="section.sectionId != formDataActive.active"
                    :resolve-action="resolveAddAction"
                    :set-action-list="AddActionList"
                    isAddBtn
                    :item-data="section"
                  />
                </div>
              </div>

              <div v-if="formQuestion.length >= 2 && idx == 0" class="z-1">
                <div
                  class="d-flex p-absolute"
                  :class="
                    question.questionId === activeIndex
                      ? 'dropdown-section-active'
                      : 'dropdown-section'
                  "
                >
                  <div class="mr-1 font-medium-5">
                    <span>After section {{ index + 1 }}</span>
                  </div>

                  <div>
                    <dropdown-action-group
                      :tagOption="section.nextstepOption"
                      :formData="section"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section-reroder-modal
      v-if="modalType.isReoderSection"
      :formQuestion="formQuestion"
      :sectionMove="formData.sectionMove"
      @onCloseModal="onCloseModalReorderSection"
      @onSaveReoder="onSaveReoder"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import IconPlus from "@core/components/svg/common/IconPlus.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-emoji/dist/quill-emoji.css";
import Quill from "quill";
import QuillEmoji from "quill-emoji";
import CustomToolbar from "../CustomToolbarEditor.vue";
import useQuestion from "../../hooks/useQuestion";
import SurveyItem from "../SurveyItem.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import DropdownActionGroup from "@/views/components/table-action-group/dropdownActionGroup.vue";
import SectionReroderModal from "../SectionReroderModal.vue";
import IconDragDrop from "@/@core/components/svg/common/IconDragDrop.vue";
import IconAdd from "@/@core/components/svg/survey/IconPlus.vue";

export default {
  components: {
    draggable,
    IconPlus,
    CustomToolbar,
    SurveyItem,
    ActionGroup,
    DropdownActionGroup,
    SectionReroderModal,
    IconDragDrop,
    IconAdd,
  },
  props: {
    formData: { type: Object, default: {} },
    formQuestion: { type: Array, default: {} },
    optionQuestion: { type: Object, default: {} },
    isEditForm: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      toggleActive,
      activeHover,
      customQuillOption,
      onFocusInput,
      componentData,
      activeIndex,
      unActiveQuestion,
      resolveSectionAction,
      sectionActionList,
      resolveAddAction,
      AddActionList,
      modalType,
      onOpenModalReorderSection,
      onCloseModalReorderSection,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      formDataActive,
      onDuplicateQuestion,
      onSaveReoder,
      resolveActionList,
      hoverQestionId,
      onHover,
      activeEditor,
    } = useQuestion(props);

    return {
      toggleActive,
      activeHover,
      customQuillOption,
      onFocusInput,
      componentData,
      activeIndex,
      unActiveQuestion,
      resolveSectionAction,
      sectionActionList,
      resolveAddAction,
      AddActionList,
      modalType,
      onOpenModalReorderSection,
      onCloseModalReorderSection,
      onAddChoice,
      onAddOther,
      onRemoveChoice,
      onUploadImage,
      onUploadImageChoice,
      formDataActive,
      onDuplicateQuestion,
      onSaveReoder,
      resolveActionList,
      hoverQestionId,
      onHover,
      activeEditor,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/quiz/toolbar-editor.css";
@import "~@/assets/css/pages/survey/question.css";
</style>

//set reoder backgroud
<style lang="scss" scoped>
#question-survey ::v-deep {
  .ghost {
    background-color: #fff !important;
  }

  .ghost .bg {
    border-left: none !important;
    border: none !important;
    padding: 9px 25px 9px 13px !important;
    background-color: transparent !important;
  }

  .ghost .card-survey-inner {
    background-color: #eee !important;
  }

  .ghost .card-survey-inner > div {
    visibility: hidden !important;
  }

  .ghost .bg-question {
    border-left: #fff !important;
    padding: 9px 20px 9px 21px !important;
    margin-left: -35px;
    border: none !important;
  }

  .ghost .bg-question-hover {
    cursor: grab;
  }

  .dragging {
    background-color: #fff !important;
  }

  .dragging .bg-question-hover .icon-reorder-hover {
    position: absolute;
    left: -25px;
    top: calc(50% - 20px);
    cursor: grab;
    fill: #2f96ef;
  }
}
</style>